export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            关于我们
          </h2>
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10">
          <div className="prose max-w-none">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              91在线视频是一个专注于<strong>精品影视内容</strong>聚合与推荐的在线平台。我们以"精选高分、热门推荐、高清播放"为核心，致力于为观众打造一个高品质、低门槛的在线观影入口。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              平台汇聚了来自全球的<strong>高分电影</strong>、热门剧集、经典佳作和新片速递等海量资源，覆盖动作、悬疑、科幻、喜剧、纪录、动画等多元类型。无论您是资深影迷还是休闲观众，都能在这里找到心仪的内容。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              我们的编辑团队每日甄选<strong>91精品视频在线</strong>优质片源，结合实时热度数据和用户口碑，生成个性化的<strong>热门推荐</strong>清单和专题合集。所有内容均支持<strong>91精品视频在线播放</strong>，采用智能码率适配技术保障流畅观影体验。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              91在线视频秉持"发现好内容，享受好时光"的理念，持续优化产品体验，让每一次点击都值得期待。我们相信，好的影视作品值得被更多人看见。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-8 border-t border-background-200/70">
            {[
              { num: '20,000+', label: '精选片源' },
              { num: '50万+', label: '日均访问' },
              { num: '99.7%', label: '播放成功率' },
              { num: '15+', label: '内容品类' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-primary-600">{stat.num}</div>
                <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}